var map = {
	"./lineal/ball.png": 650,
	"./lineal/boots.png": 709,
	"./lineal/calendar.png": 4198,
	"./lineal/cards.png": 1593,
	"./lineal/league.png": 4489,
	"./lineal/medal.png": 6099,
	"./lineal/scoreboard.png": 9252,
	"./lineal/trophy.png": 6371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7605;